import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getContinuousEducationSectionAction } from '../actions';

const {
  useLoader: useContinuousEducationSectionLoader,
  useLoaderData: useContinuousEducationSectionLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationSectionAction,
});

function ContinuousEducationSectionLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  ContinuousEducationSectionLoader,
  useContinuousEducationSectionLoaderData,
  useContinuousEducationSectionLoader,
};
